import { EntityProjectsProvider } from "./context/EntityProjects.context";

const LayoutEntityProjects = ({ content }) => {
  return (
    <EntityProjectsProvider>
      {content}
    </EntityProjectsProvider>
  )
}


export default LayoutEntityProjects;
